/**
 * Class toggled on <html> to hide the HubSpot iframe container.
 *
 * A global CSS rule in ChatManager.vue force-hides
 * `#hubspot-messages-iframe-container` while this class is present, so any code
 * that opens the widget must remove it to make the panel visible. Shared so the
 * support-widgets store and ChatManager stay in sync.
 */
export const HS_HIDE_CLASS = 'hs-widget-hidden'
